module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_inomemado-c4206fe132b7d4739504b84cc73d6bed.webp";